import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CaptureResponseComponent } from './capture-response.component';

import { PayStudentComponent } from './pay-student.component';
import { PaylayoutComponent } from './paylayout.component';




const routes: Routes = [
  {
      path: '', component: PaylayoutComponent,
      children: [


          { path: 'captureResponse', component: CaptureResponseComponent }

      ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FeePaymentRoutingModule { }
